export const DISPLAY_TYPE_LIST = 'list';
export const DISPLAY_TYPE_GRID = 'grid';
export const POD_IMAGE_ASPECT_RATIO = 1.77;
export const POD_IMAGE_MARGIN_OFFSET = 12;
